import React from "react";
import bgImg from "../../../assets/Rectangle04.png";

const eligibilityCards = [
  {
    number: "01",
    text: (
      <>
        Used Chemical Hair Relaxer Products{" "}
        For <span className="font-bold">Four Or More Years</span>
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
  {
    number: "02",
    text: (
      <>
        Used The Product{" "}
        <span className="font-bold">Multiple Times</span> Per Year
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },
  {
    number: "03",
    text: (
      <>
        Were Later Diagnosed With:
        <ul className="list-disc ml-5 mt-1">
          <li>Uterine Cancer</li>
          <li>Ovarian Cancer</li>
          <li>Endometrial Cancer</li>
        </ul>
      </>
    ),
    bg: "bg-[#F3F4F9]",
  },
  {
    number: "04",
    text: (
      <>
        Were Diagnosed Within Several Years Of Your Product Use. If You Are
        Unsure Whether You Qualify,{" "}
        <span className="font-bold">Submit Your Information</span> For A Free
        Case Review.
      </>
    ),
    bg: "bg-[#FDF9ED]",
  },
];

const mobileEligibilityCards = eligibilityCards.map((card, index) => {
  if (index % 2 === 0) {
    return { ...card, bg: "!bg-[#FDF9ED]" };
  }
  return { ...card, bg: "!bg-[#F3F4F9]" };
});

export default function EligibilityCriteria() {
  return (
    <section
      className="w-full bg-white py-12 font-[Quicksand] bg-cover"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      {/* Desktop / Laptop */}
      <div className="hidden lg:block max-w-[1280px] mx-auto px-6 lg:px-8">
        <div className="flex h-[320px] xl:h-[360px] gap-6 xl:gap-8">
          
          {/* Left Side */}
          <div className="flex flex-col justify-center w-[43.61%]">
            <h2 className="text-[#0A1F8F] text-[28px] xl:text-[36px] font-semibold leading-tight mb-2">
              You May <span className="text-[#EDC14A]">Qualify</span> To File
              <br />
              A Hair Relaxer Lawsuit If You
            </h2>

            <p className="text-[#757575] text-[15px] xl:text-[18px] leading-[22px] xl:leading-[25px] font-medium">
              Unsure?{" "}
              <a
                href="#contact-form"
                className="text-[#EDC14A] hover:text-[#d4a841] transition-colors duration-200 underline"
              >
                Submit the form
              </a>{" "}
              above to check eligibility at no cost.
            </p>
          </div>

          {/* Cards */}
          <div className="w-[56.39%] grid grid-cols-2 gap-6 xl:gap-7">
            {eligibilityCards.map((card) => (
              <article
                key={card.number}
                className={`flex flex-col justify-center items-start gap-2 p-6 xl:p-8 h-[140px] xl:h-[160px] rounded-[10px] ${card.bg} shadow-sm border border-white overflow-hidden`}
              >
                <span className="text-[#0A1F8F] font-normal leading-none text-[28px] xl:text-[32px]">
                  {card.number}
                </span>

                <div className="text-[#0A1F8F] text-[14px] xl:text-[15px] font-medium leading-[20px] xl:leading-[22px] tracking-[-0.32px] text-left">
                  {card.text}
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>

      {/* Tablet */}
      <div className="hidden md:flex lg:hidden max-w-[1200px] mx-auto flex-col items-center gap-6 px-4">
        
        <div className="w-full text-center">
          <h2 className="text-[#0A1F8F] text-[28px] font-semibold leading-normal">
            You May <span className="text-[#EDC14A]">Qualify</span> To File
            <br />
            A Hair Relaxer Lawsuit If You
          </h2>

          <p className="text-[#757575] text-[14px] font-medium mt-4 leading-[22px]">
            Unsure?{" "}
            <a
              href="#contact-form"
              className="text-[#EDC14A] hover:text-[#d4a841] transition-colors duration-200 underline"
            >
              Submit the form
            </a>{" "}
            above to check eligibility at no cost.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {eligibilityCards.map((card) => (
            <article
              key={card.number}
              className={`flex flex-col justify-center items-start gap-3 p-6 h-[150px] rounded-[10px] ${card.bg} shadow-sm border border-white`}
            >
              <span className="text-[#0A1F8F] font-normal leading-none text-[26px]">
                {card.number}
              </span>

              <div className="text-[#0A1F8F] text-[14px] font-medium leading-[20px] text-left">
                {card.text}
              </div>
            </article>
          ))}
        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden flex flex-col gap-6 px-4">
        
        <h2 className="text-[#0A1F8F] text-[24px] font-semibold leading-snug">
          You May <span className="text-[#EDC14A]">Qualify</span> To File
          <br />
          A Hair Relaxer Lawsuit If You
        </h2>

        <p className="text-[#757575] text-[14px] font-medium leading-[22px]">
          Unsure?{" "}
          <a
            href="#contact-form"
            className="text-[#EDC14A] hover:text-[#d4a841] transition-colors duration-200 underline"
          >
            Submit the form
          </a>{" "}
          above to check eligibility at no cost.
        </p>

        <div className="flex flex-col gap-5 w-full max-w-[360px]">
          {mobileEligibilityCards.map((card) => (
            <article
              key={card.number}
              className={`flex flex-col justify-center items-start gap-3 p-5 h-auto rounded-[10px] ${card.bg} shadow-sm border border-white`}
            >
              <span className="text-[#0A1F8F] text-[30px] font-normal leading-none">
                {card.number}
              </span>

              <div className="text-[#0A1F8F] text-[15px] font-medium leading-[20px]">
                {card.text}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}